import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from 'store'
import LoginForm from 'ui/LoginForm'
require('./login.css')

const QR_VERSION = '20260427-01'
const PASSWORD_QRIMG = `/wxacode/password?envVersion=trial&v=${QR_VERSION}`
const REGIST_QRIMG = `/wxacode/regist?envVersion=trial&v=${QR_VERSION}`

const Head = () => {
  return (
    <div class="login-head">
      <div class="login-name">{'\u97f3\u4fe1'}</div>
    </div>
  )
}

const PasswordForm = () => {
  return (
    <div>
      <div class="c">{'\u626b\u7801\u540e\u5c06\u76f4\u8fbe\u5c0f\u7a0b\u5e8f\u3010\u4fee\u6539\u5bc6\u7801\u3011\u9875\u9762\u3002'}</div>
      <img class="qrimg" src={PASSWORD_QRIMG}/>
    </div>
  )
}

const RegistForm = () => {
  return (
    <div>
      <div class="c">{'\u626b\u7801\u540e\u5c06\u76f4\u8fbe\u5c0f\u7a0b\u5e8f\u3010\u7533\u8bf7\u540e\u53f0\u7ba1\u7406\u5458\u3011\u9875\u9762\u3002'}</div>
      <img class="qrimg" src={REGIST_QRIMG}/>
    </div>
  )
}

@observer
export default class Login extends Component {
  render() {
    const { form_panel } = store
    return (
      <div class="modal">
        <div class="login-content">
          <Head />
          {do {
            if (form_panel == 'login') {
              <LoginForm />
            } else if (form_panel == 'password') {
              <PasswordForm />
            } else if (form_panel == 'regist') {
              <RegistForm />
            }
          }}
          {do {
            if (form_panel == 'login') {
              <div class="actions">
                <a onClick={e => {
                  e.preventDefault()
                  store.setFormPanel('password')
                }}>{'\u91cd\u7f6e\u5bc6\u7801'}</a>
                <a onClick={e => {
                  e.preventDefault()
                  store.setFormPanel('regist')
                }}>{'\u6ce8\u518c\u8d26\u53f7'}</a>
              </div>
            } else {
              <div class="center">
                <a onClick={e => {
                  e.preventDefault()
                  store.setFormPanel('login')
                }}>{'\u8fd4\u56de'}</a>
              </div>
            }
          }}
        </div>
      </div>
    )
  }
}
